/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon24Solid = forwardRef('ArrowDim1HIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.972 5.528a1.375 1.375 0 0 1 0 1.944L4.82 10.625H19.18l-3.153-3.153a1.375 1.375 0 1 1 1.945-1.944l4.44 4.44a2.875 2.875 0 0 1 0 4.065l-4.44 4.44a1.375 1.375 0 0 1-1.945-1.945l3.153-3.153H4.82l3.152 3.153a1.375 1.375 0 0 1-1.944 1.945l-4.44-4.44a2.875 2.875 0 0 1 0-4.066l4.44-4.44a1.375 1.375 0 0 1 1.944 0Z" })));
});
